/* src/app/pages/download/component.scss */
/*# sourceMappingURL=component.css.map */
